import { NextRouter } from 'next/router'

export const getFullUrlFromRouter = (router: NextRouter): string => {
  return window.location.origin + router.asPath
}
